<template>
  <!-- Promise-based delete confirm: `await this.$refs.confirmDelete.ask({ message, target, note })` → true/false.
       Same look as the Tax Config V2 page's own delete dialog. -->
  <v-dialog v-model="open" max-width="520px" persistent data-testid="confirm-delete-dialog">
    <v-card>
      <v-card-title class="bg-error text-white">
        <v-icon class="mr-2">mdi-alert-circle</v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-alert v-if="note" type="warning" variant="tonal" class="mb-4">
          {{ note }}
        </v-alert>
        <p>{{ message }}</p>
        <p v-if="target" class="font-weight-bold text-primary">{{ target }}</p>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn data-testid="confirm-delete-cancel-btn" variant="outlined" @click="settle(false)">
          <v-icon start>mdi-close</v-icon>
          ยกเลิก
        </v-btn>
        <v-btn data-testid="confirm-delete-confirm-btn" color="error" variant="elevated" @click="settle(true)">
          <v-icon start>mdi-delete</v-icon>
          ลบ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDeleteDialog',
  data() {
    return {
      open: false,
      title: 'ยืนยันการลบ',
      message: '',
      target: '',
      note: '',
      resolver: null,
    };
  },
  beforeUnmount() {
    this.settle(false);
  },
  methods: {
    ask({ title, message, target, note } = {}) {
      // A second ask while one is open cancels the first.
      this.settle(false);
      this.title = title || 'ยืนยันการลบ';
      this.message = message || 'ต้องการลบรายการนี้ใช่หรือไม่?';
      this.target = target == null ? '' : String(target);
      this.note = note || '';
      this.open = true;
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    settle(result) {
      this.open = false;
      const resolve = this.resolver;
      this.resolver = null;
      if (resolve) resolve(result);
    },
  },
};
</script>
